import { useMagnetic } from '../hooks';

// Wrapper that makes its child gently follow the cursor on hover.
function Magnetic({ strength = 0.2, children }) {
  const ref = useMagnetic(strength);
  return (
    <span className="magnetic" ref={ref}>
      {children}
    </span>
  );
}

export default Magnetic;
